import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@features/auth/services/auth-service';

export const AuthenticatedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isAuth = authService.isAuthenticated();
  const isGuest = authService.isGuest();

  if (isAuth || isGuest) {
    return true;
  }

  return router.parseUrl('/auth/login');
};
